import {useEffect,useState} from 'react';
import {getApiUrl} from '../config/serverEndpoint';
import {accountHeaders} from './accountFetch';
export default function useFestivePreviewAccess(username){
 const token=sessionStorage.getItem('reconnectToken');
 const [grant,setGrant]=useState(null);
 useEffect(()=>{
  const controller=new AbortController();let live=true,generation=0;
  setGrant(null);
  const check=async()=>{
   const request=++generation;
   if(!username||!token)return;
   try{
    const response=await fetch(getApiUrl(`/festive-preview/access?username=${encodeURIComponent(username)}`),{headers:accountHeaders(),cache:'no-store',signal:controller.signal});
    const value=await response.json();
    if(live&&request===generation&&!controller.signal.aborted)setGrant(response.ok&&value.allowed===true?{username,token}:null);
   }catch(_){if(live&&request===generation)setGrant(null);}
  };
  check();window.addEventListener('focus',check);
  return()=>{live=false;controller.abort();window.removeEventListener('focus',check);};
 },[username,token]);
 return Boolean(username&&token&&grant?.username===username&&grant?.token===token);
}
